module.exports = __webpack_public_path__ + "static/media/declined-icon.c157873f.svg";